import type {
  NewsletterSubscriptionRequest,
  NewsletterSubscriptionResponse,
} from '../types';

/**
 * Newsletter API service using native fetch
 */
export class NewsletterApiService {
  /**
   * Subscribe to newsletter
   * @param email - User's email address
   * @returns Promise with subscription response
   */
  static async subscribeNewsletter(
    email: string
  ): Promise<NewsletterSubscriptionResponse> {
    const baseURL = import.meta.env.VITE_BASE_API_URL;
    const requestData: NewsletterSubscriptionRequest = { email };

    try {
      const response = await fetch(
        `${baseURL}/sanur-api/v1/subscribe-newsletter`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify(requestData),
        }
      );

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(
          errorData.message || `HTTP error! status: ${response.status}`
        );
      }

      const result = await response.json();
      return result;
    } catch (error) {
      // Normalize the error
      if (error instanceof Error) {
        throw {
          message: error.message,
          status: 500,
          code: 'NETWORK_ERROR',
          details: null,
        };
      }
      throw error;
    }
  }
}

// Export individual functions for convenience
export const subscribeNewsletter = NewsletterApiService.subscribeNewsletter;
